<div class="modal-header">
  <h4 class="modal-title">{{"optimistic-lock.modal.title" | translate}}</h4>
  <button (click)="activeModal.dismiss()" [ngbTooltip]="'modal.close' | translate" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">{{"optimistic-lock.modal.body" | translate}}</div>
<div class="modal-footer">
  <button (click)="activeModal.dismiss()" class="btn btn-outline-primary" type="button">
    {{ "optimistic-lock.modal.back" | translate }}
  </button>
  <button (click)="activeModal.close()" class="btn btn-primary" type="button">
    {{ "optimistic-lock.modal.continue" | translate }}
  </button>
</div>
